<template>
    <flex-container v-if="!isIpad()" align="center">
        <editor-dropdown
            :editor="editor"
            save-key="dropdownFontOpen"
            @handle:open="$emit('handle:open', $event)"
            hide-scroll
            :chevron="true"
            ref="dropdownFont"
        >
            <template #handler>
                <svg
                    width="18"
                    :data-tippy-content="t('builder.builder_text_settings')"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path
                        d="M11.246 15H4.75416L2.75416 20H0.600098L7.0001 4H9.0001L15.4001 20H13.246L11.246 15ZM10.446 13L8.0001 6.88516L5.55416 13H10.446ZM21.0001 12.5351V12H23.0001V20H21.0001V19.4649C20.4118 19.8052 19.7287 20 19.0001 20C16.791 20 15.0001 18.2091 15.0001 16C15.0001 13.7909 16.791 12 19.0001 12C19.7287 12 20.4118 12.1948 21.0001 12.5351ZM19.0001 18C20.1047 18 21.0001 17.1046 21.0001 16C21.0001 14.8954 20.1047 14 19.0001 14C17.8955 14 17.0001 14.8954 17.0001 16C17.0001 17.1046 17.8955 18 19.0001 18Z"
                    ></path>
                </svg>
            </template>
            <template #content>
                <EditorFontStyleContent :editor="editor" />
            </template>
        </editor-dropdown>
    </flex-container>
    <button
        v-else
        @click="$emit('toggle:mobile')"
        class="editor-button editor-button_padding flex items-center editor-button_fill"
        :class="{ active: isOpen }"
    >
        <svg
            width="18"
            :data-tippy-content="t('builder.builder_text_settings')"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <path
                d="M11.246 15H4.75416L2.75416 20H0.600098L7.0001 4H9.0001L15.4001 20H13.246L11.246 15ZM10.446 13L8.0001 6.88516L5.55416 13H10.446ZM21.0001 12.5351V12H23.0001V20H21.0001V19.4649C20.4118 19.8052 19.7287 20 19.0001 20C16.791 20 15.0001 18.2091 15.0001 16C15.0001 13.7909 16.791 12 19.0001 12C19.7287 12 20.4118 12.1948 21.0001 12.5351ZM19.0001 18C20.1047 18 21.0001 17.1046 21.0001 16C21.0001 14.8954 20.1047 14 19.0001 14C17.8955 14 17.0001 14.8954 17.0001 16C17.0001 17.1046 17.8955 18 19.0001 18Z"
            ></path>
        </svg>

        <DropdownChevronIcon
            :style="{ transform: isOpen ? 'rotate(180deg)' : 'none' }"
            width="6"
            height="5"
            style="margin-left: 4px"
            fill="#53595c"
        />
    </button>
</template>

<script>
import EditorDropdown from "@components/Editor/components/EditorDropdown.vue"
import FlexContainer from "@components/Containers/FlexContainer.vue"
import EditorFontStyleContent from "@components/Editor/components/EditorFontStyleContent.vue"
import DropdownChevronIcon from "@icons/DropdownChevronIcon.vue"
import checkDevice from "@mixins/checkDevice"

export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        editor: {
            type: Object,
            default: () => {}
        }
    },
    name: "EditorFontStyle",
    mixins: [checkDevice],
    components: { DropdownChevronIcon, EditorFontStyleContent, FlexContainer, EditorDropdown },
    data() {
        return {}
    }
}
</script>

<style lang="sass" scoped>
.font-overflow
    max-width: 160px
    overflow: hidden
    text-overflow: ellipsis
</style>
